import servicesProvider from "./ServicesProvider";

export default class PiattoService {
    getPiattoById(ristoranteId: string, piattoId: string) {
        return servicesProvider.getPiattoDbQueries().selectPiattoById(ristoranteId, piattoId);
    }

    async getAllPiatto(ristoranteId: string) {
        return await servicesProvider.getPiattoDbQueries().selectAllPiatto(ristoranteId);
    }
}